<template>
  <div class="p-4">
    <user-config-page></user-config-page>
  </div>
</template>
<script>
import UserConfigPage from './UserConfigPage.vue';

export default {
  components: {
    UserConfigPage,
  },
};
</script>
